// Helper lib to store session data. Can be used by both DI and non-DI services/lib
import {
  PLANS,
  CookieKey,
  getCookie,
  setCookie,
  getServerUrl,
} from 'mt-shared';
import { IResponseUser } from '../services/company.interface';

const SERVER_URL: string = getServerUrl();
export const STORAGE_KEY: string = 'groupsFilterIds'; // global groups filter key for dashboard storage
let sessionData: IResponseUser;

export function setSessionData(data: IResponseUser) {
  data.groups = data.groups || [];
  sessionData = data;
  const userId: string = getCookie(CookieKey.USER_ID);
  if (+userId !== data.id) {
    if (userId !== undefined) {
      setCookie(CookieKey.DASHBOARD_STORAGE, JSON.stringify({ STORAGE_KEY: [] }));
    }
    setCookie(CookieKey.USER_ID, data.id);
  }
}

export function getSessionData(): IResponseUser {
  return sessionData;
}

export function setUserInfoToCookie(
  paidVSFree: boolean,
  activePlan: string,
  hasAssetGateWay: boolean,
  isDashcamUser: boolean,
  customerFleetSize: number,
): void {
  const userInformation = {
    paid: paidVSFree ? 1 : 0,
    active_plan: Object.values(PLANS).indexOf(activePlan),
    eld_user: paidVSFree ? 1 : 0,
    asset_gateway: hasAssetGateWay ? 1 : 0,
    dashcam_user: isDashcamUser ? 1 : 0,
    customer_fleet_size: customerFleetSize,
  };

  const websiteUrl: string = `.${SERVER_URL.split('//')[1]}`;

  const cookieArgs: any = {
    expires: 60,
    domain: websiteUrl,
  };

  setCookie(CookieKey.USER_INFORMATION, JSON.stringify(userInformation), cookieArgs);
}

export function setUniversalPixelCookie(
  isCustomer: boolean,
  isFleetCardApplicationDeclined: boolean,
  customerFleetSize: number,
  userId: number,
  isFleetAdmin: boolean,
) {

  const cookieValues = {
    is_customer: isCustomer,
    is_fleet_card_application_declined: isFleetCardApplicationDeclined,
    composite_fleet_size: customerFleetSize,
    user_id: userId,
    is_fleet_admin: isFleetAdmin,
  };

  setCookie(CookieKey.UNIVERSAL_PIXEL, JSON.stringify(cookieValues));
}
